import React, { Component } from 'react';
import {
  Button,
  FormGroup, Label,
  Row, Col,
  Card, CardBody
} from 'reactstrap';
import Ionicon from 'react-ionicons';
import AddEditSubsidiariesService from '../../services/AddEditSubsidiariesService';
import swal from 'sweetalert';
import ListSubsidiaries from '../ListSubsidiaries/ListSubsidiaries';
import { messages } from '../../constants/constant.message';
import NewFleetBusinessDetail from '../NewFleetBusinessDetail/NewFleetBusinessDetail';
import NewFleetPrimaryContactDetail from '../NewFleetPrimaryContactDetail/NewFleetPrimaryContactDetail';
import NewFleetPersonalDetails from '../NewFleetPersonalDetails/NewFleetPersonalDetails';
import NewFleetBusinessRelatedDetails from '../NewFleetBusinessRelatedDetails/NewFleetBusinessRelatedDetails';
import Storage from '../../services/Storage';
import NewFleetService from '../../services/NewFleetService';
import ModalService from '../../services/ModalService';
import Validation from '../../services/Validation';
import Moment from 'react-moment';
import TextareaAutosize from 'react-textarea-autosize';
import Lightbox from 'react-image-lightbox';
import "react-image-lightbox/style.css";
import VehicleCountDeatil from '../VehicleCountDeatil/VehicleCountDeatil';
import FleetService from '../../services/FleetService';
import { Roles } from '../../constants/constant.role';
class NewFleetDetail extends Component {


  constructor(props) {
    super(props);
    this.state = {
      uuid: null,
      userDetail: Storage.getUserDetail(),
      isLoading: false,
      addEditSubsidiaries: [],
      isEditBusinessDetail: false,
      isEditPrimaryContactDetail: false,
      isEditPersonalDetail: false,
      isEditBusinessRelatedDetail: false,
      isNoDataBusinessRelatedDetails: true,
      isOpenLightbox: false,
      isFleeData: false,
      fleetByIdData: {},
      fleet_manager: null,
      fleet_manager_name: null,
      salesManagerData: [],
      areaSalesManagerData: [],
      imagesDisplay: [],
      depotData: [],
      showBuildMyFleet: false,
      activeFragment: null,
      controls: {
        approve: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        remark: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        truck: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        bus: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        scv: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        lcv: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        profile_picture: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        selfie_with_fleet_owner: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false,
          isUploadedImage: false
        },
        fleet_office_inside_photo: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false,
          isUploadedImage: false
        },
        fleet_office_outside_photo: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false,
          isUploadedImage: false
        }
      },
      fleetData: [],
      business_related_detail_data: []
    }
    this.childNewFleetBusinessDetail = React.createRef();
    this.childNewFleetPrimaryContactDetail = React.createRef();
    this.childNewFleetPersonalDetails = React.createRef();
    this.childNewFleetBusinessRelatedDetails = React.createRef();
  }

  resetState = () => {
    this.setState({
      uuid: null,
      userDetail: Storage.getUserDetail(),
      isLoading: false,
      addEditSubsidiaries: [],
      isEditBusinessDetail: false,
      isEditPrimaryContactDetail: false,
      isEditPersonalDetail: false,
      isEditBusinessRelatedDetail: false,
      isFleeData: false,
      fleetByIdData: {},
      fleet_manager: null,
      fleet_manager_name: null,
      depotData: [],
      showBuildMyFleet: false,
      activeFragment: null,
      controls: {
        approve: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        remark: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        truck: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        bus: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        scv: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        lcv: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        profile_picture: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        selfie_with_fleet_owner: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false,
          isUploadedImage: false
        },
        fleet_office_inside_photo: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false,
          isUploadedImage: false
        },
        fleet_office_outside_photo: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false,
          isUploadedImage: false
        }
      }
    })
  }
  activeFragment = (fragment) => {
    //  this.setState({ activeFragment: fragment });
  }

  scrorllToFLeetData = () => {
    // debugger
    // let scroller = Scroll.scroller;
    // scroller.scrollTo('VehicleCountDeatil', {
    //   duration: 1000,
    //   delay: 100,
    //   smooth: "easeInOutQuint",
    //   offset: -80,
    //   containerId: 'ScrollElementNewFleetDetail',
    // })
  }

  async getBusinessRelatedDetail() {
    let { business_related_detail_data } = this.state;
    try {
      const { data } = await FleetService.getBusinessRelatedDetails(this.props.fleetByIdData.uuid);

      if (data.data && data.data.length > 0) {
        business_related_detail_data = data.data;
      } else {
        business_related_detail_data = [];
      }
      this.setState({
        business_related_detail_data
      })
    } catch (error) {
      console.log(error);
    }

  }
  async getFleetData() {
    let { fleetData } = this.state;
    try {
      this.setState({
        isLoading: true
      })
      const { data } = await FleetService.getFleetData(this.props.fleetByIdData.uuid);
      if (data) {
        fleetData = data.data;
        this.setState({ fleetData: data.data });
        let totalCountBus = 0, totalCountTruck = 0, totalCountLcv = 0,
          totalCountScv = 0, totalCountIcv = 0, totalCountPickup = 0, totalCountRetread = false,
          totalWheelTruck=0,
          totalWheelBus=0,
          totalWheelSCV=0,
          totalWheelLCV=0,
          totalWheelICV=0,
          totalWheelPickup=0
          ;
        data.data.forEach(element => {
          let count = 0;
          if (element.type.toLowerCase() === 'retread') {
            count = element.data[0].number_of_tyres_vehicle_count.tyres_per_month;
          } else {
            for (let [value] of Object.entries(element.data[0].number_of_tyres_vehicle_count)) {
              if (value) {
                count += value;
              }
            }
          }
          if (element.type.toLowerCase() === 'truck') {
            totalCountTruck = count;
            totalWheelTruck =element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'bus') {
            totalCountBus = count;
            totalWheelBus =element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'scv') {
            totalCountScv = count;
            totalWheelSCV =element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'lcv') {
            totalCountLcv = count;
            totalWheelLCV =element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'icv') {
            totalCountIcv = count;
            totalWheelICV =element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'pickup') {
            totalCountPickup = count;
            totalWheelPickup =element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'retread') {
            totalCountRetread = true;
          }
        });
        this.refs.refCountVehicleDetail.setData({
          totalCountBus: totalCountBus,
          totalCountTruck: totalCountTruck,
          totalCountLcv: totalCountLcv,
          totalCountScv: totalCountScv,
          totalCountIcv: totalCountIcv,
          totalCountPickup: totalCountPickup,
          totalCountRetread: totalCountRetread,
          totalWheelTruck: totalWheelTruck,
          totalWheelBus: totalWheelBus,
          totalWheelSCV: totalWheelSCV,
          totalWheelLCV: totalWheelLCV,
          totalWheelICV: totalWheelICV,
          totalWheelPickup: totalWheelPickup
        }, false);
      }

      this.setState({ isLoading: false });
    } catch (error) {
      this.setState({
        isLoading: false
      })
      console.log(error);
    }
  }




  getAMSM = async () => {
    if (!this.state.userDetail.region_id) {
      return
    }
    try {
      const { data } = await NewFleetService.getAMSM(this.state.userDetail.region_id);
      if (data && data.data) {
        this.setState({
          salesManagerData: data.data[0].region_manager,
          areaSalesManagerData: data.data[0].area_manager
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  getDepot = async () => {
    if (!this.state.userDetail.region_id) {
      return
    }
    try {
      const { data } = await NewFleetService.getDepot(this.state.userDetail.region_id);
      if (data && data.data) {
        this.setState({
          depotData: data.data
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  setFleetData = () => {
    this.resetState();
    if (this.props.fleetByIdData && Object.keys(this.props.fleetByIdData).length > 0) {
      this.getFleetData();
      this.getBusinessRelatedDetail();
      let { controls } = this.state;
      controls.profile_picture.value = this.props.fleetByIdData.profile_picture;
      controls.selfie_with_fleet_owner.value = this.props.fleetByIdData.selfie_with_fleet_owner;
      controls.fleet_office_inside_photo.value = this.props.fleetByIdData.fleet_office_inside_photo;
      controls.fleet_office_outside_photo.value = this.props.fleetByIdData.fleet_office_outside_photo;
      let isNoDataBusinessRelatedDetails = true;
      if (typeof this.props.fleetByIdData.business_related_detail === 'object') {
        isNoDataBusinessRelatedDetails = false;
      } else {
        this.props.fleetByIdData.business_related_detail.forEach(row => {
          if (row.radial || row.bias || row.reason) {
            isNoDataBusinessRelatedDetails = false;
          }
        });
      }
      this.setState({
        fleetByIdData: this.props.fleetByIdData,
        controls,
        isEditBusinessDetail: false,
        isEditPrimaryContactDetail: false,
        isEditPersonalDetail: false,
        isEditBusinessRelatedDetail: false,
        isNoDataBusinessRelatedDetails: isNoDataBusinessRelatedDetails
      })
      this.childNewFleetBusinessDetail.current.setFleetDetail();
      this.childNewFleetPrimaryContactDetail.current.setFleetDetail();
      this.childNewFleetPersonalDetails.current.setFleetDetail();
      this.childNewFleetBusinessRelatedDetails.current.setFleetDetail();
    }
  }



  componentDidMount() {
    this.getAMSM();
    this.getDepot();
    this.setState({
      fleet_manager: this.state.userDetail && this.state.userDetail.uuid ? this.state.userDetail.uuid : null,
      fleet_manager_name: this.state.userDetail && this.state.userDetail.owner_name ? this.state.userDetail.owner_name : null,
    }, () => {
      this.scrorllToFLeetData();
    })
  }


  editSubsidiaries = (index, display = false) => {
    this.props.editSubsidiaries(index, display);
  }

  removeSubsidiaries = (id) => {
    AddEditSubsidiariesService.deleteSubsidiaries({ id }, this.state.fleetByIdData.uuid)
      .then(response => {
        document.body.style.overflow = 'auto';
        swal('Deleted Subsidiary', messages.ADD_EDIT_SUBSIDIARIES.SUCCESS_DELETED_SUBSIDIARIES, 'success');
        this.props.getSubsidiaries();
      })
      .catch(e => {
        if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
          swal('', e.response.data.error[0].message, 'error');
        }
      });
  }

  editDetails = (flag, type) => {
    if (type === 'business detail') {
      this.setState({
        isEditBusinessDetail: flag
      })

    } else if (type === 'primary contact detail') {
      this.setState({
        isEditPrimaryContactDetail: flag
      })

    } else if (type === 'business related detail') {
      this.setState({
        isEditBusinessRelatedDetail: flag
      })
    } else if (type === 'personal detail') {
      this.setState({
        isEditPersonalDetail: flag
      });
    }

  }


  handleValidation = (isSubmit = false) => {
    let { controls, isValidForm } = this.state;
    let { selfie_with_fleet_owner, fleet_office_inside_photo, fleet_office_outside_photo } = controls;

    if (selfie_with_fleet_owner.touched === true || isSubmit) {
      selfie_with_fleet_owner = Validation.notNullValidator(selfie_with_fleet_owner);
      selfie_with_fleet_owner.valid = !(selfie_with_fleet_owner.nullValue);
      if (selfie_with_fleet_owner.valid === false) {
        selfie_with_fleet_owner.showErrorMsg = true;
      } else {
        selfie_with_fleet_owner.showErrorMsg = false;
      }
    }

    if (fleet_office_inside_photo.touched === true || isSubmit) {
      fleet_office_inside_photo = Validation.notNullValidator(fleet_office_inside_photo);
      fleet_office_inside_photo.valid = !(fleet_office_inside_photo.nullValue);
      if (fleet_office_inside_photo.valid === false) {
        fleet_office_inside_photo.showErrorMsg = true;
      } else {
        fleet_office_inside_photo.showErrorMsg = false;
      }
    }

    if (fleet_office_outside_photo.touched === true || isSubmit) {
      fleet_office_outside_photo = Validation.notNullValidator(fleet_office_outside_photo);
      fleet_office_outside_photo.valid = !(fleet_office_outside_photo.nullValue);
      if (fleet_office_outside_photo.valid === false) {
        fleet_office_outside_photo.showErrorMsg = true;
      } else {
        fleet_office_outside_photo.showErrorMsg = false;
      }
    }

    if (selfie_with_fleet_owner.valid === true &&
      fleet_office_inside_photo.valid === true &&
      fleet_office_outside_photo.valid === true) {
      isValidForm = true;
    } else {
      isValidForm = false;
    }


    this.setState({ controls, isValidForm });
    return isValidForm;

  }

  checkAllValidation() {
    let form1 = true; let form2 = true; let form3 = true; let form4 = true;
    if (this.childNewFleetBusinessDetail.current && !this.childNewFleetBusinessDetail.current.handleValidation(true)) {
      form1 = false;
    }
    if (this.childNewFleetPrimaryContactDetail.current && !this.childNewFleetPrimaryContactDetail.current.handleValidation(true)) {
      form2 = false;
    }
    if (this.childNewFleetPersonalDetails.current && !this.childNewFleetPersonalDetails.current.handleValidation(true)) {
      form3 = false;
    }
    if (!this.handleValidation(true)) {
      form4 = false;
    }
    return !!(form1 === true && form2 === true && form3 === true && form4 === true);
  }

  submitToZMFM = async (is_draft = true) => {
    const { salesManagerData, controls } = this.state;
    if (!is_draft) {
      if (!this.checkAllValidation()) {
        return;
      }
    }
    let reqData = {};
    if (this.childNewFleetBusinessDetail.current) {
      let controlsNewFleetBusinessDetail = this.childNewFleetBusinessDetail.current.state.controls;
      reqData.company_name = controlsNewFleetBusinessDetail.company_name.value;
      reqData.company_type = controlsNewFleetBusinessDetail.company_type.value;
      reqData.owner_name = controlsNewFleetBusinessDetail.owner_name.value;
      reqData.designation = controlsNewFleetBusinessDetail.designation.value;
      reqData.mobile_number = controlsNewFleetBusinessDetail.mobile_number.value;
      reqData.phone_number = controlsNewFleetBusinessDetail.phone_number.value;
      reqData.whatsapp_number = controlsNewFleetBusinessDetail.whatsapp_number.value;
      reqData.email = controlsNewFleetBusinessDetail.email.value;
      reqData.website = controlsNewFleetBusinessDetail.website.value;
      reqData.address = controlsNewFleetBusinessDetail.address.value;
      reqData.city = controlsNewFleetBusinessDetail.city.value;
      reqData.state = controlsNewFleetBusinessDetail.state.value;
      reqData.pin_code = controlsNewFleetBusinessDetail.pin_code.value;
      reqData.pan_number = controlsNewFleetBusinessDetail.pan_number.value;
      reqData.gst_number = controlsNewFleetBusinessDetail.gst_number.value;
      reqData.fleet_manger_name = this.state.userDetail.uuid;
      reqData.depot = controlsNewFleetBusinessDetail.depot.value;
      reqData.region = this.state.userDetail.region_id;
      reqData.sales_officer = controlsNewFleetBusinessDetail.sales_officer.value;
      reqData.sales_manager = salesManagerData.length > 0 ? salesManagerData[0].uuid : '';
      reqData.area_sales_manager = controlsNewFleetBusinessDetail.area_sales_manager.value;
      reqData.enrollment_type = controlsNewFleetBusinessDetail.enrollment_type.value;
    }

    if (this.childNewFleetPrimaryContactDetail.current) {
      let controlsNewFleetPrimaryContactDetail = this.childNewFleetPrimaryContactDetail.current.state.controls;
      reqData.primary_contact_person = controlsNewFleetPrimaryContactDetail.primary_contact_person.value;
      reqData.primary_contact_designation = controlsNewFleetPrimaryContactDetail.primary_contact_designation.value;
      reqData.primary_mobile_number = controlsNewFleetPrimaryContactDetail.primary_mobile_number.value;
      reqData.primary_whatsapp_number = controlsNewFleetPrimaryContactDetail.primary_whatsapp_number.value;
      reqData.primary_email = controlsNewFleetPrimaryContactDetail.primary_email.value;
    }

    if (this.childNewFleetPersonalDetails.current) {
      reqData.languages = [];
      let controlsNewFleetPersonalDetails = this.childNewFleetPersonalDetails.current.state.controls;
      if (controlsNewFleetPersonalDetails.languages.value && controlsNewFleetPersonalDetails.languages.value.length > 0) {
        controlsNewFleetPersonalDetails.languages.value.forEach(element => {
          reqData.languages.push(element.label);
        });
      }
      reqData.home_address = controlsNewFleetPersonalDetails.home_address.value;
      reqData.birth_date = controlsNewFleetPersonalDetails.birth_date.value;
      reqData.education_qualification = controlsNewFleetPersonalDetails.education_qualification.value;
      reqData.marital_status = controlsNewFleetPersonalDetails.marital_status.value === 'Married' ? true : false;
      reqData.anniversary_date = controlsNewFleetPersonalDetails.anniversary_date.value;
      reqData.spouse_name = controlsNewFleetPersonalDetails.spouse_name.value;
      reqData.spouse_dob = controlsNewFleetPersonalDetails.spouse_dob.value;
      reqData.child_1_name = controlsNewFleetPersonalDetails.child_1_name.value;
      reqData.child_1_dob = controlsNewFleetPersonalDetails.child_1_dob.value;
      reqData.child_2_name = controlsNewFleetPersonalDetails.child_2_name.value;
      reqData.child_2_dob = controlsNewFleetPersonalDetails.child_2_dob.value;
    }

    if (this.childNewFleetBusinessRelatedDetails.current) {
      reqData.business_related_detail = this.childNewFleetBusinessRelatedDetails.current.state.controls;
    }
    reqData.profile_picture = controls.profile_picture.value;
    reqData.selfie_with_fleet_owner = controls.selfie_with_fleet_owner.value;
    reqData.fleet_office_inside_photo = controls.fleet_office_inside_photo.value;
    reqData.fleet_office_outside_photo = controls.fleet_office_outside_photo.value;
    reqData.uuid = this.state.fleetByIdData.uuid;
    reqData.is_draft = is_draft;
    this.props.isDataLoding(true);
    NewFleetService.editInviteFleet(reqData)
      .then(data => {
        if (data.data) {
          swal({
            title: 'Congratulations !',
            text: data.data.message,
            icon: 'success',
            type: 'success',
          }).then(value => {
            this.props.onCloseSidebar();
            this.props.getNewFleets();
          });
        }
        this.props.isDataLoding(false);
      })
      .catch(e => {
        if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
          ModalService.openAlert(e.response.data.error[0].message, '', 'error');
        }
        this.props.isDataLoding(false);
      });
  }


  uploadFleetDoc = (event, type) => {
    const file = event.target.files[0];
    this.setState({ isLoading: true });
    const obj = {
      file
    };
    let { controls } = this.state;
    NewFleetService.uploadFleetDoc(obj, 'profile')
      .then(res => {
        if (res.data) {
          if (type === 'fileInputUploadSelfie') {
            controls.selfie_with_fleet_owner.value = res.data.data.imageUrl;
            controls.selfie_with_fleet_owner.showErrorMsg = false;
            controls.selfie_with_fleet_owner.isUploadedImage = true;
          } else if (type === 'fileInputUploadFleetOfficeInside') {
            controls.fleet_office_inside_photo.value = res.data.data.imageUrl;
            controls.fleet_office_inside_photo.isUploadedImage = true;
            controls.fleet_office_inside_photo.showErrorMsg = false;
          } else if (type === 'fileInputUploadFleetOficeOuside') {
            controls.fleet_office_outside_photo.value = res.data.data.imageUrl;
            controls.fleet_office_outside_photo.isUploadedImage = true;
            controls.fleet_office_outside_photo.showErrorMsg = false;
          } else if (type === 'profile') {
            controls.profile_picture.value = res.data.data.imageUrl;
          }
          this.setState({
            controls,
            isLoading: false
          });
        }
      })
      .catch(e => {
        if (type === 'fileInputUploadSelfie') {
          controls.selfie_with_fleet_owner.showErrorMsg = true;
          controls.selfie_with_fleet_owner.isUploadedImage = false;
        } else if (type === 'fileInputUploadFleetOfficeInside') {
          controls.fleet_office_inside_photo.showErrorMsg = true;
          controls.fleet_office_inside_photo.isUploadedImage = false;
        } else if (type === 'fileInputUploadFleetOficeOuside') {
          controls.fleet_office_outside_photo.showErrorMsg = true;
          controls.fleet_office_outside_photo.isUploadedImage = false;
        }
        this.setState({
          controls,
          isLoading: false
        });
      });
  }

  buildMyFleetClick = (flag) => {
    this.props.buildMyFleetClick(flag);
  }

  subsidiaresSidebarOpen = () => {
    this.props.subsidiaresSidebarOpen(true);
  }

  handleValidation = (isSubmit = false) => {
    let { controls, isValidForm } = this.state;
    let { selfie_with_fleet_owner, fleet_office_inside_photo, fleet_office_outside_photo } = controls;

    if (selfie_with_fleet_owner.touched === true || isSubmit) {
      selfie_with_fleet_owner = Validation.notNullValidator(selfie_with_fleet_owner);
      selfie_with_fleet_owner.valid = !(selfie_with_fleet_owner.nullValue);
      if (selfie_with_fleet_owner.valid === false) {
        selfie_with_fleet_owner.showErrorMsg = true;
      } else {
        selfie_with_fleet_owner.showErrorMsg = false;
      }
    }

    if (fleet_office_inside_photo.touched === true || isSubmit) {
      fleet_office_inside_photo = Validation.notNullValidator(fleet_office_inside_photo);
      fleet_office_inside_photo.valid = !(fleet_office_inside_photo.nullValue);
      if (fleet_office_inside_photo.valid === false) {
        fleet_office_inside_photo.showErrorMsg = true;
      } else {
        fleet_office_inside_photo.showErrorMsg = false;
      }
    }

    if (fleet_office_outside_photo.touched === true || isSubmit) {
      fleet_office_outside_photo = Validation.notNullValidator(fleet_office_outside_photo);
      fleet_office_outside_photo.valid = !(fleet_office_outside_photo.nullValue);
      if (fleet_office_outside_photo.valid === false) {
        fleet_office_outside_photo.showErrorMsg = true;
      } else {
        fleet_office_outside_photo.showErrorMsg = false;
      }
    }

    if (selfie_with_fleet_owner.valid === true &&
      fleet_office_inside_photo.valid === true &&
      fleet_office_outside_photo.valid === true) {
      isValidForm = true;
    } else {
      isValidForm = false;
    }


    this.setState({ controls, isValidForm });
    return isValidForm;

  }

  handleValidationZFM = (isSubmit = false) => {
    let { controls, isValidForm } = this.state;
    let { approve } = controls;

    if (approve.touched === true || isSubmit) {
      approve = Validation.notNullValidator(approve);
      approve.valid = !(approve.nullValue);
      if (approve.valid === false) {
        approve.showErrorMsg = true;
      } else {
        approve.showErrorMsg = false;
      }
    }

    if (approve.valid === true) {
      isValidForm = true;
    } else {
      isValidForm = false;
    }


    this.setState({ controls, isValidForm });
    return isValidForm;
  }

  handleInputChange = (e) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;
    controls[controlName].value = controlValue;
    controls[controlName].touched = true;
    this.setState({ controls });
    this.handleValidationZFM();
  }

  proceedVerifyInvitedFleet = () => {
    const { controls, fleetByIdData } = this.state;
    let reqData = {
      approve: controls.approve.value,
      id: fleetByIdData.uuid
    }
    if (controls.remark.value) {
      reqData.remark = controls.remark.value;
    }
    this.props.isDataLoding(true);
    NewFleetService.verifyInvitedFleet(reqData, this.state.fleetByIdData.is_prospective)
      .then(data => {
        if (data.data) {
          swal({
            title: 'Fleet Status Update',
            text: data.data.message,
            icon: 'success',
            type: 'success',
          }).then(value => {
            this.props.onCloseSidebar();
            this.props.getNewFleets();
          });
        }
        this.props.isDataLoding(false);
      })
      .catch(e => {
        this.props.isDataLoding(false);
        if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
          ModalService.openAlert(e.response.data.error[0].message, '', 'error');
        }
      });
  }

  updateStatusByZFM = () => {
    const { controls } = this.state;
    if (!this.handleValidationZFM(true)) {
      return
    }
    if (controls.approve.value === 'reject') {
      ModalService.openAlertWithPopup('',
        this.state.fleetByIdData.is_prospective ? 'Are you sure you want to reject the prospective fleet request?' : 'Are you sure you want to reject the new fleet request?', '', ['No', 'Yes'], (isConfirm) => {
          if (isConfirm) {
            this.proceedVerifyInvitedFleet();
          }
        });
    } else {
      this.proceedVerifyInvitedFleet();
    }
  }

  openLightBox = (img) => {
    let { imagesDisplay } = this.state;
    imagesDisplay = [];
    imagesDisplay.push(img);
    this.setState({
      imagesDisplay,
      isOpenLightbox: true
    })
  }


  displayFleetDetail = (type) => {
    this.props.displayFleetDetail(this.state.fleetByIdData.uuid, type);
  }

  render() {
    const {
      isEditBusinessDetail, isEditPrimaryContactDetail, isEditPersonalDetail, isEditBusinessRelatedDetail, fleetByIdData,
      controls, userDetail, isOpenLightbox,
      imagesDisplay } = this.state;
    const { isListSubsidiaries, addEditSubsidiaries } = this.props;
    let photoIndex = 0;
    return (
      <>
        {isOpenLightbox && (
          <Lightbox
            mainSrc={imagesDisplay[photoIndex]}
            nextSrc={0}
            prevSrc={0}
            onCloseRequest={() => this.setState({ isOpenLightbox: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + imagesDisplay.length - 1) % imagesDisplay.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % imagesDisplay.length,
              })
            }
          />
        )}

        <div id="profile-detail">
          {/* {(this.state.isLoading || true) && <CustomSpinner />} */}
          <Row style={{ marginTop: '10px', marginLeft: '0', marginRight: '0' }}>
            <Col className="text-align-center" xl="3" md="3" xs="3">
              {!controls.profile_picture.value && <img src="images/Web_Avatar.svg" height="50px" width="auto" className="profile-image" alt="" />}
              {controls.profile_picture.value && <img src={controls.profile_picture.value}
                onClick={() => this.openLightBox(controls.profile_picture.value)}
                height="50px" width="auto" className="profile-image" alt="" />}
              {/* {this.state.isImageUpdating && <Spinner size="sm" color="primary" className="profile-spinner" />} */}
              {
                fleetByIdData.is_draft &&
                <div className="create-icon-con text-align-center hidden">
                  <label className="profile-image-camera-side">
                    <div className="edit-icon">
                      <Ionicon icon="md-camera" fontSize="24px" color="#fff" />
                    </div>
                    {/* <img src="images/profile.svg" alt="profile image" className="profile-upload-image-icon"></img> */}
                    <input accept="image/*" type="file" className="visibility-hidden width-0" onChange={(e) => { this.uploadFleetDoc(e, 'profile') }} />
                  </label>
                </div>
              }
            </Col>
            <Col className='d-flex-row'>
              <span className='lbl-profile' style={{ marginTop: '50px' }}>{fleetByIdData.owner_name ? fleetByIdData.owner_name : '--'}</span>
            </Col>
          </Row>


          <Row style={{ marginTop: '20px', marginLeft: '0', marginRight: '5px' }}>
            <Col xl="12" md="12" xs="12">
              <span className='lbl-profile' style={{ fontSize: '14px' }}>PHOTOS</span>
            </Col>
            <br />
            <Col xl="12" md="12" xs="12">
              <Row style={{ marginTop: '0px', marginLeft: '0', marginBottom: '20px' }}>
                <Col className="text-align-left d-flex-column" xl="4" md="4" xs="4" style={{ marginLeft: '-11px' }}>
                  <Label className="text-align-left">Selfie with fleet owner</Label>
                  {!controls.selfie_with_fleet_owner.value && <img src="images/cam_placeholder.png" height="140px" width="140px" className="profile-image" alt=""
                    style={{ borderRadius: '0', height: "140px", width: "140px" }} />}
                  {controls.selfie_with_fleet_owner.value && <img src={controls.selfie_with_fleet_owner.value}
                    onClick={() => this.openLightBox(controls.selfie_with_fleet_owner.value)} height="130px" width="auto"
                    className="profile-image cursor-pointer" alt="" style={{ borderRadius: '0', height: "140px", width: "200px" }} />}
                  {
                    fleetByIdData.is_draft &&
                    <div className="create-icon-con text-align-center hidden" style={{ marginTop: '-140px', marginRight: '-60px' }}>
                      <label className="profile-image-camera-side">
                        <div className="edit-icon" style={{ backgroundColor: 'inherit' }}>
                          <Ionicon icon="md-create" fontSize="24px" color="#fff" />
                        </div>

                        <input accept="image/*" type="file" className="visibility-hidden width-0" onChange={(e) => { this.uploadFleetDoc(e, 'fileInputUploadSelfie') }} />
                      </label>
                    </div>
                  }

                  {controls.selfie_with_fleet_owner.value && <span onClick={() => this.openLightBox(controls.selfie_with_fleet_owner.value)} className="link-blue font-weight-bold">View Image</span>
                  }
                </Col>
                <Col xl="4" md="4" xs="4" className="d-flex-column">
                  <Label className="text-align-left">Fleet office - Inside Photo</Label>
                  {!controls.fleet_office_inside_photo.value && <img src="images/cam_placeholder.png" height="130px" width="auto" className="profile-image" alt="" style={{ borderRadius: '0', height: "140px", width: "140px" }} />}
                  {controls.fleet_office_inside_photo.value && <img src={controls.fleet_office_inside_photo.value}
                    onClick={() => this.openLightBox(controls.fleet_office_inside_photo.value)} height="130px" width="auto" className="profile-image cursor-pointer" alt="" style={{ borderRadius: '0', height: "140px", width: "200px" }} />}
                  {
                    fleetByIdData.is_draft && <div className="create-icon-con text-align-center hidden" style={{ marginTop: '-140px', marginRight: '-60x' }}>
                      <label className="profile-image-camera-side">
                        <div className="edit-icon" style={{ backgroundColor: 'inherit' }}>
                          <Ionicon icon="md-create" fontSize="24px" color="#fff" />
                        </div>
                        <input accept="image/*" type="file" className="visibility-hidden width-0" onChange={(e) => { this.uploadFleetDoc(e, 'fileInputUploadFleetOfficeInside') }} />
                      </label>
                    </div>
                  }
                  {controls.fleet_office_inside_photo.showErrorMsg && <div className="error error-message-new-fleet-images">*Please upload fleet office - inside Photo.</div>}
                  {
                    controls.fleet_office_inside_photo.value && <span onClick={() => this.openLightBox(controls.fleet_office_inside_photo.value)} className="link-blue font-weight-bold">View Image</span>
                  }
                </Col>
                <Col xl="4" md="4" xs="4" className="d-flex-column">
                  <Label className="text-align-left">Fleet office - Outside Photo</Label>
                  {!controls.fleet_office_outside_photo.value && <img src="images/cam_placeholder.png" height="130px" width="auto" className="profile-image" alt="" style={{ borderRadius: '0', height: "140px", width: "140px" }} />}
                  {controls.fleet_office_outside_photo.value && <img src={controls.fleet_office_outside_photo.value}
                    onClick={() => this.openLightBox(controls.fleet_office_outside_photo.value)} height="130px" width="auto" className="profile-image cursor-pointer" alt="" style={{ borderRadius: '0', height: "140px", width: "200px" }} />}
                  {
                    fleetByIdData.is_draft &&
                    <div className="create-icon-con text-align-center hidden" style={{ marginTop: '-140px', marginRight: '-60px' }}>
                      <label className="profile-image-camera-side">
                        <div className="edit-icon" style={{ backgroundColor: 'inherit' }}>
                          <Ionicon icon="md-create" fontSize="24px" color="#fff" />
                        </div>

                        <input accept="image/*" type="file" className="visibility-hidden width-0" onChange={(e) => { this.uploadFleetDoc(e, 'fileInputUploadFleetOficeOuside') }} />
                      </label>
                    </div>
                  }
                  {controls.fleet_office_outside_photo.showErrorMsg && <div className="error error-message-new-fleet-images">*Please upload fleet office - outside Photo.</div>}
                  {
                    controls.fleet_office_outside_photo.value && <span onClick={() => this.openLightBox(controls.fleet_office_outside_photo.value)} className="link-blue font-weight-bold">View Image</span>
                  }
                </Col>
              </Row>
            </Col>
            <br />
            <Col xl="9" md="12" xs="12">
              {
                isListSubsidiaries && <ListSubsidiaries
                  listSubsidiaries={Object.assign([], addEditSubsidiaries)}
                  removeSubsidiaries={(id) => this.removeSubsidiaries(id)}
                  addMoreSubsidiaries={this.subsidiaresSidebarOpen}
                  is_draft={true}
                  editSubsidiaries={this.editSubsidiaries} />
              }
            </Col>

            {/* BUSINESS DETAIILS */}

            <Col xl="12" md="12" xs="12" className={isEditBusinessDetail ? 'hidden' : ''}
              style={{ paddingRight: '30px', marginTop: '20px' }}>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <div className='d-flex-row' style={{ justifyContent: 'space-between' }}>
                        <b className="margin-right-16">BUSINESS DETAIILS</b>
                        {
                          fleetByIdData.is_draft &&
                          <Col xl="2" md="2" xs="2" className="text-align-right cursor-pointer hidden">
                            <Ionicon icon="md-create" fontSize="24px" color="#fdbb1f" onClick={() => { this.editDetails(true, 'business detail') }} />
                          </Col>
                        }
                      </div>
                    </Col>
                  </Row>
                  <hr style={{ marginLeft: '-18px', marginRight: '-18px' }} />
                  <Row>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Company Name<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold">{fleetByIdData.company_name ? fleetByIdData.company_name : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Company Type<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.company_type ? fleetByIdData.company_type : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Owner Name<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.owner_name ? fleetByIdData.owner_name : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Designation<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.designation ? fleetByIdData.designation : '--'}</span>
                    </Col>
                  </Row>
                  <br />
                  <Row>

                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Mobile Number<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold">{fleetByIdData.mobile_number ? '+91 ' + fleetByIdData.mobile_number : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Phone Number<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold">{fleetByIdData.phone_number ? fleetByIdData.phone_number : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Whatsapp Number<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold">{fleetByIdData.whatsapp_number ? '+91 ' + fleetByIdData.whatsapp_number : '--'}</span>
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Email Address<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold">{fleetByIdData.email ? fleetByIdData.email : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Website</Label>
                      <span className="detail-lbl font-weight-bold">{fleetByIdData.website ? fleetByIdData.website : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">PAN<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold">{fleetByIdData.pan_number ? fleetByIdData.pan_number.toUpperCase() : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">GSTIN<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold">{fleetByIdData.gst_number ? fleetByIdData.gst_number.toUpperCase() : '--'}</span>
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Address<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.address ? fleetByIdData.designation : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">State<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.state_name ? fleetByIdData.state_name : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">City<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.city_name ? fleetByIdData.city_name : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Pincode<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold">{fleetByIdData.pin_code ? fleetByIdData.pin_code : '--'}</span>
                    </Col>
                  </Row>
                  <br />
                  {/* <Row>

                  </Row>
                  <br /> */}
                  <Row>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Fleet Manager<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold">{fleetByIdData.fleet_manager_name ? fleetByIdData.fleet_manager_name : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Depot<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.depot_name ? fleetByIdData.depot_name : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Region<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.region_name ? fleetByIdData.region_name : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Sales Officer</Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.sales_officer ? fleetByIdData.sales_officer : '--'}</span>
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Sales Manager<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.sales_manager_name ? fleetByIdData.sales_manager_name : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Area Sales Manager<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.area_sales_manager_name ? fleetByIdData.area_sales_manager_name : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Billing Type</Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.enrollment_type ? fleetByIdData.enrollment_type : '--'}</span>
                    </Col>
                    {
                      (fleetByIdData.enrollment_type === 'direct' || fleetByIdData.enrollment_type === 'mobility') &&
                      <Col xl="3" md="12" xs="12" className='d-flex-column'>
                        <Label for="company_name">SAP ID</Label>
                        <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.sap_id ? fleetByIdData.sap_id : '--'}</span>
                      </Col>
                    }
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <div className={!isEditBusinessDetail ? 'hidden' : ''}>
              <Col xl="12" md="12" xs="12" style={{ paddingRight: '30px', marginTop: '20px' }}>
                <NewFleetBusinessDetail
                  fleetByIdData={fleetByIdData} ref={this.childNewFleetBusinessDetail}
                  salesManagerData={this.state.salesManagerData}
                  areaSalesManagerData={this.state.areaSalesManagerData}
                  depotData={this.state.depotData}
                  fleet_manager={this.state.fleet_manager}
                  fleet_manager_name={this.state.fleet_manager_name}
                  userDetail={userDetail} />
              </Col>
              <Row className="text-align-right" style={{ width: '100%', justifyContent: 'flex-end', marginTop: '10px' }}>
                <Button className="mb-1 mr-1 btn-pill action-button profile-cancel-button" color="dark" onClick={() => { this.editDetails(false, 'business detail') }}>Close</Button>&nbsp;&nbsp;
            </Row>
            </div>


            {/* PRIMARY CONTACT DETAIILS */}

            <Col xl="12" md="12" xs="12" className={isEditPrimaryContactDetail ? 'hidden' : ''} style={{ paddingRight: '30px', marginTop: '20px' }}>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <div className='d-flex-row' style={{ justifyContent: 'space-between' }}>
                        <b className="margin-right-16">PRIMARY CONTACT DETAILS</b>
                        {
                          fleetByIdData.is_draft &&
                          <Col xl="2" md="2" xs="2" className="text-align-right cursor-pointer hidden">
                            <Ionicon icon="md-create" fontSize="24px" color="#fdbb1f" onClick={() => { this.editDetails(true, 'primary contact detail') }} />
                          </Col>
                        }
                      </div>
                    </Col>
                  </Row>
                  <hr style={{ marginLeft: '-18px', marginRight: '-18px' }} />
                  <Row>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Contact Person<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.primary_contact_person ? fleetByIdData.primary_contact_person : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Designation<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.primary_contact_designation ? fleetByIdData.primary_contact_designation : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Mobile Number<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold">{fleetByIdData.primary_mobile_number ? '+91 ' + fleetByIdData.primary_mobile_number : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Whatsapp Number<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold">{fleetByIdData.primary_whatsapp_number ? '+91 ' + fleetByIdData.primary_whatsapp_number : '--'}</span>
                    </Col>
                  </Row>

                  <br />
                  <Row>
                    <Col xl="6" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Email Address<span className="required-field">*</span></Label>
                      <span className="detail-lbl font-weight-bold">{fleetByIdData.primary_email ? fleetByIdData.primary_email : '--'}</span>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <div className={!isEditPrimaryContactDetail ? 'hidden' : ''}>
              <Col xl="12" md="12" xs="12" style={{ paddingRight: '30px', marginTop: '20px' }}>
                <NewFleetPrimaryContactDetail
                  NewFleetBusinessDetail={this.childNewFleetBusinessDetail}
                  fleetByIdData={fleetByIdData} ref={this.childNewFleetPrimaryContactDetail}
                  userDetail={userDetail} />
              </Col>
              <Row className="text-align-right" style={{ width: '100%', justifyContent: 'flex-end', marginTop: '10px' }}>
                <Button className="mb-1 mr-1 btn-pill action-button profile-cancel-button" color="dark" onClick={() => { this.editDetails(false, 'primary contact detail') }}>Close</Button>&nbsp;&nbsp;
            </Row>
            </div>
            {/* PERSONAL DETAIILS */}

            <Col className={isEditPersonalDetail ? 'hidden' : ''} xl="12" md="12" xs="12" style={{ paddingRight: '30px', marginTop: '20px' }}>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <div className='d-flex-row' style={{ justifyContent: 'space-between' }}>
                        <b className="margin-right-16">PERSONAL DETAIILS</b>
                        {
                          fleetByIdData.is_draft &&
                          <Col xl="2" md="2" xs="2" className="text-align-right cursor-pointer hidden">
                            <Ionicon icon="md-create" fontSize="24px" color="#fdbb1f" onClick={() => { this.editDetails(true, 'personal detail') }} />
                          </Col>
                        }
                      </div>
                    </Col>
                  </Row>
                  <hr style={{ marginLeft: '-18px', marginRight: '-18px' }} />
                  <Row>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Home Address</Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.home_address ? fleetByIdData.home_address : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Date of Birth</Label>
                      <span className="detail-lbl font-weight-bold">{fleetByIdData.birth_date ? <Moment format="DD MMM YYYY">
                        {fleetByIdData.birth_date}
                      </Moment> : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Educational Qualification</Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.education_qualification ? fleetByIdData.education_qualification : '--'}</span>
                    </Col>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Languages Known</Label>
                      <div className="detail-lbl font-weight-bold">
                        <ol style={{ paddingLeft: '17px' }}>
                          {
                            fleetByIdData.languages && fleetByIdData.languages.map((item, i) => (
                              <li className="text-capitalize">{item}</li>
                            ))
                          }
                        </ol>
                      </div>
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col xl="3" md="12" xs="12" className='d-flex-column'>
                      <Label for="company_name">Marital Status</Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.marital_status ? 'Married' : 'Unmarried'}</span>
                    </Col>
                    {
                      fleetByIdData.marital_status && <>
                        <Col xl="3" md="12" xs="12" className='d-flex-column'>
                          <Label for="company_name">Date of Anniversary</Label>
                          <span className="detail-lbl font-weight-bold">{fleetByIdData.anniversary_date ? <Moment format="DD MMM YYYY">
                            {fleetByIdData.anniversary_date}
                          </Moment> : '--'}</span>
                        </Col>
                        <Col xl="3" md="12" xs="12" className='d-flex-column'>
                          <Label for="company_name">Spouse Name</Label>
                          <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.spouse_name ? fleetByIdData.spouse_name : '--'}</span>
                        </Col>
                        <Col xl="3" md="12" xs="12" className='d-flex-column'>
                          <Label for="company_name">Spouse DOB</Label>
                          <span className="detail-lbl font-weight-bold">{fleetByIdData.spouse_dob ? <Moment format="DD MMM YYYY">
                            {fleetByIdData.spouse_dob}
                          </Moment> : '--'}</span>
                        </Col>
                      </>
                    }

                  </Row>
                  {
                    fleetByIdData.marital_status && <>
                      <br />
                      <Row>
                        <Col xl="3" md="12" xs="12" className='d-flex-column'>
                          <Label for="company_name">Child 1 Name</Label>
                          <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.child_1_name ? fleetByIdData.child_1_name : '--'}</span>
                        </Col>
                        <Col xl="3" md="12" xs="12" className='d-flex-column'>
                          <Label for="company_name">Child 1 DOB</Label>
                          <span className="detail-lbl font-weight-bold">{fleetByIdData.child_1_dob ? <Moment format="DD MMM YYYY">
                            {fleetByIdData.child_1_dob}
                          </Moment> : '--'}</span>
                        </Col>
                        <Col xl="3" md="12" xs="12" className='d-flex-column'>
                          <Label for="company_name">Child 2 Name</Label>
                          <span className="detail-lbl font-weight-bold text-capitalize">{fleetByIdData.child_2_name ? fleetByIdData.child_2_name : '--'}</span>
                        </Col>
                        <Col xl="3" md="12" xs="12" className='d-flex-column'>
                          <Label for="company_name">Child 2 DOB</Label>
                          <span className="detail-lbl font-weight-bold">{fleetByIdData.child_2_dob ? <Moment format="DD MMM YYYY">
                            {fleetByIdData.child_2_dob}
                          </Moment> : '--'}</span>
                        </Col>
                      </Row>
                    </>
                  }
                </CardBody>
              </Card>
            </Col>
            <div className={!isEditPersonalDetail ? 'hidden' : ''}>
              <Col xl="12" md="12" xs="12" style={{ paddingRight: '30px', marginTop: '20px' }}>
                <NewFleetPersonalDetails
                  fleetByIdData={fleetByIdData} ref={this.childNewFleetPersonalDetails}
                  userDetail={userDetail} />
              </Col>
              <Row className="text-align-right" style={{ width: '100%', justifyContent: 'flex-end', marginTop: '10px' }}>
                <Button className="mb-1 mr-1 btn-pill action-button profile-cancel-button" color="dark" onClick={() => { this.editDetails(false, 'personal detail') }}>Close</Button>&nbsp;&nbsp;
            </Row>
            </div>

            {/* <Row style={{ margin: '0', paddingRight: '10px', paddingLeft: '10px', marginBottom: '20px', width: '100%' }}>
              <Col xs="6">
                <br />
                {
                  !isListSubsidiaries &&
                  <Button onClick={(e) => this.buildMyFleetClick(true)} style={{ width: '100%' }} className="mb-1 mr-1 btn-pill action-button profile-cancel-button" color="dark" onClick={() => this.subsidiaresSidebarOpen(true)}>ADD SUBSIDIARY</Button>
                }
              </Col>
              <Col xs="6">
                <br />
                {
                  !isFleeData &&
                  <Button onClick={(e) => this.buildMyFleetClick(true)} className="mb-1 mr-1 btn-pill action-button profile-cancel-button" color="dark" onClick={() => this.submitToZMFM(true)} style={{ width: '100%' }}>BUILD MY FLEET</Button>
                }
              </Col>
            </Row> */}

            <Col xl="12">
              {/* <EditFleetDetail
                className={activeFragment === 'fleet' ? 'card-yellow-border' : ''}
                truck={controls_fleet_registration.truck}
                bus={controls_fleet_registration.bus}
                scv={controls_fleet_registration.scv}
                lcv={controls_fleet_registration.lcv}
                handleInputChange={this.handleInputChange}
                buildMyFleetClick={this.buildMyFleetClick}
                isFleeData={isFleeData}
                is_draft={false}
              /> */}
              <div className='w-100' id="VehicleCountDeatil">
                <VehicleCountDeatil
                  ref="refCountVehicleDetail"
                  isDisable={true}
                  displayFleetDetail={this.displayFleetDetail}
                  uuid={this.state.uuid}
                />
              </div>
            </Col>
            {/* <VehcileRelatedDetails
              business_related_detail_data={this.state.business_related_detail_data ? this.state.business_related_detail_data : []}
            /> */}
            {/* BUSINESS RELATED DETAIILS */}
            {/* <Card style={{ marginTop: '5px' }}></Card> */}
            <div className={!isEditBusinessRelatedDetail ? 'hidden' : ''}>
              <Col xl="12" md="12" xs="12" style={{ paddingRight: '30px', marginTop: '20px' }}>
                <NewFleetBusinessRelatedDetails
                  fleetByIdData={fleetByIdData} ref={this.childNewFleetBusinessRelatedDetails}
                  userDetail={userDetail} />

              </Col>
              <Row className="text-align-right" style={{ width: '100%', justifyContent: 'flex-end', marginTop: '10px' }}>
                <Button className="mb-1 mr-1 btn-pill action-button profile-cancel-button" color="dark" onClick={() => { this.editDetails(false, 'business related detail') }}>Close</Button>&nbsp;&nbsp;
            </Row>
            </div>
          </Row>

          {/* {
            fleetByIdData.is_draft && this.state.userDetail && this.state.userDetail.type && this.state.userDetail.type === Roles.FLEET_MANAGER_ROLE && <Row className="text-align-right" style={{ width: '100%', justifyContent: 'flex-end', marginTop: '10px' }}>
              <Button className="mb-1 mr-1 btn-pill action-button profile-cancel-button" color="dark" onClick={() => this.submitToZMFM(true)}>Save As Draft</Button>&nbsp;&nbsp;
    <Button className="mb-1 mr-1 btn-pill action-button font-weight-bold" color="warning" onClick={() => { this.submitToZMFM(false); }}>Submit to ZMFM For Approval</Button>
            </Row>
          } */}

          {/* Approve Reject Fleet Detail */}
          {
            this.state.userDetail && this.state.userDetail.type && this.state.userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE &&
              this.props.custom_status && (this.props.custom_status === 'pending' || this.props.custom_status === 'modification') ?
              <Col xl="12" md="12" xs="12" style={{ paddingRight: '30px', marginTop: '20px' }}>
                <Card>
                  <CardBody>
                    <Row>
                      <Col>
                        <div className='d-flex-row' style={{ justifyContent: 'space-between' }}>
                          <b className="margin-right-16">{fleetByIdData.is_prospective ? 'Prospective Fleet Status Update' :
                            'Fleet Status Update'}</b>
                        </div>
                      </Col>
                    </Row>
                    <hr style={{ marginLeft: '-18px', marginRight: '-18px' }} />
                    <Row>
                      <Col xl="4" md="12" xs="12" className='d-flex-column'>
                        <FormGroup>
                          <Label for="company_name">Status<span className="required-field">*</span></Label>
                          <select className="form-control" name="approve"
                            onChange={(e) => this.handleInputChange(e)} value={controls.approve.value}>
                            <option value="" selected disabled>Select status</option>
                            <option value="approve">Approve</option>
                            <option value="reject">Reject</option>
                            <option value="modification">Modifcation Needed</option>
                          </select>
                          {controls.approve.showErrorMsg && <div className="error">*Please select status.</div>}
                        </FormGroup>
                      </Col>
                      <Col xl="6" md="12" xs="12" className='d-flex-column'>
                        <Label for="company_name">Remark</Label>
                        <TextareaAutosize
                          name="remark"
                          autocomplete="nofill"
                          id="remark"
                          value={controls.remark.value}
                          style={{ maxHeight: 100, fontSize: '14px' }}
                          className="form-control"
                          onChange={(e) => this.handleInputChange({ target: { name: 'remark', value: e.target.value } })}
                          placeholder='Type here'
                        />


                        {/* <Input
                        type="text"
                        name="remark"
                        id="remark"
                        onChange={(e) => this.handleInputChange(e)}
                        value={controls.remark.value}
                        placeholder="Type here" /> */}
                      </Col>
                    </Row>
                    <Row className="text-align-right" style={{ width: '100%', justifyContent: 'flex-end', marginTop: '10px' }}>
                      <Button className="mb-1 mr-1 btn-pill action-button font-weight-bold" color="warning" onClick={() => { this.updateStatusByZFM(); }}>Submit</Button>
                    </Row>
                  </CardBody>
                </Card>
              </Col> : ""
          }
        </div>

        <br /> <br /> <br /> <br />
      </>
    );
  }
}

export default NewFleetDetail;